import { AbstractModel } from '@/models/abstractModel';
import type { ILeagueDailyCoverageRowApi } from '@/types/leagueDailyCoverage';

export class LeagueDailyCoverageItem extends AbstractModel {
    betdaq: number;
    bf: number;
    eventsCount: number;
    isTradeballNetwork: number;
    matchbook: number;
    name: string;
    pinna: number;
    sportId: number;

    constructor(data: ILeagueDailyCoverageRowApi) {
        super();
        this.name = data.name;
        this.sportId = data.sport_id;
        this.isTradeballNetwork = data.isTradeballNetwork;
        this.eventsCount = data.eventsCount;
        this.pinna = data.pinna;
        this.bf = data.bf;
        this.matchbook = data.matchbook;
        this.betdaq = data.betdaq;
    }

    get betdaqDisplay(): { text: string; className: string } {
        return this.coverageDisplay(this.betdaq);
    }

    get bfDisplay(): { text: string; className: string } {
        return this.coverageDisplay(this.bf);
    }

    get matchbookDisplay(): { text: string; className: string } {
        return this.coverageDisplay(this.matchbook);
    }

    get pinnaDisplay(): { text: string; className: string } {
        return this.coverageDisplay(this.pinna);
    }

    get tradeballNetworkCount(): number {
        return this.isTradeballNetwork ? this.eventsCount : 0;
    }

    get tradeballNetworkDisplay(): { text: string; className: string } {
        return this.isTradeballNetwork
            ? { text: `${this.t('common.yes')} (${this.eventsCount})`, className: 'text-tbGreen' }
            : { text: this.t('common.no'), className: 'text-tbRed' };
    }

    coverageDisplay(count: number): { text: string; className: string } {
        if (count > 0) {
            return { text: `${this.t('common.yes')} (${count})`, className: 'text-tbGreen' };
        }
        return { text: this.t('common.no'), className: 'text-tbRed' };
    }
}
